<template>
  <div>
    <div>
      <ValidationProvider
        ref="postcodeObserver"
        v-slot="{ errors }"
        mode="lazy"
        rules="required"
      >
        <Postcode
          v-model="details.postcode"
          :postcode="details.postcode"
          :errors="errors[0]"
          name="fakepasswordremembered"
          label="pcode"
          type="pcode"
          :disabled-lookup="disabledLookup"
          @handleChange="handlePostcodeChange"
          @input="handleInputChange"
        />
      </ValidationProvider>
    </div>
    <div class="form-group control has-icons-right" style="display: none">
      <ValidationProvider
        ref="houseObserver"
        v-slot="{ errors }"
        mode="lazy"
        rules="required"
      >
        <input
          id="house"
          v-model="details.house"
          :class="{ 'is-danger': errors[0] }"
          type="text"
          class="input"
        />
        <label class="form-control-placeholder" for="house">
          House number
        </label>
        <span v-if="errors[0]" class="icon is-danger is-small is-right">
          <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
        </span>
        <span :class="{ 'is-danger': errors[0] }" class="help">{{
          errors[0]
        }}</span>
      </ValidationProvider>
    </div>
    <div class="form-group control has-icons-right" style="display: none">
      <ValidationProvider
        ref="streetObserver"
        v-slot="{ errors }"
        mode="lazy"
        rules="required"
      >
        <input
          id="street"
          v-model="details.street"
          :class="{ 'is-danger': errors[0] }"
          type="text"
          class="input"
        />
        <label class="form-control-placeholder" for="street">
          Street address
        </label>
        <span v-if="errors[0]" class="icon is-danger is-small is-right">
          <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
        </span>
        <span :class="{ 'is-danger': errors[0] }" class="help">{{
          errors[0]
        }}</span>
      </ValidationProvider>
    </div>
    <div class="form-group control has-icons-right" style="display: none">
      <ValidationProvider
        ref="cityObserver"
        v-slot="{ errors }"
        mode="lazy"
        rules="required"
      >
        <input
          id="city"
          v-model="details.city"
          :class="{ 'is-danger': errors[0] }"
          type="text"
          class="input"
        />
        <label class="form-control-placeholder" for="city"> Town / City </label>
        <span v-if="errors[0]" class="icon is-danger is-small is-right">
          <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
        </span>
        <span :class="{ 'is-danger': errors[0] }" class="help">{{
          errors[0]
        }}</span>
      </ValidationProvider>
    </div>
    <div class="form-group control has-icons-right" style="display: none">
      <ValidationProvider
        ref="countyObserver"
        v-slot="{ errors }"
        mode="lazy"
        rules="required"
      >
        <input
          id="county"
          v-model="details.county"
          :class="{ 'is-danger': errors[0] }"
          type="text"
          class="input"
        />
        <label class="form-control-placeholder" for="county"> County </label>
        <span v-if="errors[0]" class="icon is-danger is-small is-right">
          <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
        </span>
        <span :class="{ 'is-danger': errors[0] }" class="help">{{
          errors[0]
        }}</span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import Postcode from '@/components/common/Postcode'

export default {
  components: { Postcode },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabledLookup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      details: {
        house: '',
        street: '',
        city: '',
        county: '',
        postcode: '',
      },
    }
  },
  methods: {
    async continueToMonthlyPayment() {
      const houseObserver = await this.$refs.houseObserver.validate()
      const streetObserver = await this.$refs.streetObserver.validate()
      const cityObserver = await this.$refs.cityObserver.validate()
      const countyObserver = await this.$refs.countyObserver.validate()
      const postcodeObserver = await this.$refs.postcodeObserver.validate()
      if (
        houseObserver.valid &&
        streetObserver.valid &&
        cityObserver.valid &&
        countyObserver.valid &&
        postcodeObserver.valid
      ) {
        console.log('valid')
      } else {
        console.log('Not Valid')
      }
    },
    handlePostcodeChange(result) {
      this.details.house = result.address
      this.details.street = result.street
      this.details.city = result.city
      this.details.county = result.county
      this.details.postcode = result.postcode
      this.$emit('input', this.details)
    },
    handleInputChange(value) {
      // Without the address lookup there is nothing to pick but the postcode
      // itself, so the typed value is kept for the parent to check.
      this.details = {
        house: '',
        street: '',
        city: '',
        county: '',
        postcode: this.disabledLookup ? value : '',
      }
      this.$emit('input', this.details)
    },
  },
}
</script>

<style lang="scss" scoped></style>
